import { __extends } from "tslib";
import { UserVipInfo, } from '../../base/common/value-objects/user-vip-info/user-vip-info';
import { ValueObject, } from '../../base/ddd-types/value-object';
import { ACCOUNT_TYPE } from '@tencent/ark-model';
var Collaborate = /** @class */ (function (_super) {
    __extends(Collaborate, _super);
    function Collaborate(obj) {
        var _this = _super.call(this) || this;
        _this.userType = 1 /* USER_TYPE.Guest */;
        _this.vipInfo = new UserVipInfo({});
        _this.sessionType = 0;
        _this.uuid = '';
        _this.status = '';
        _this.colorId = '';
        _this.corpName = '';
        _this.userPic = '';
        _this.markName = '';
        _this.uin = '';
        _this.userId = '';
        _this.uidSource = ACCOUNT_TYPE.UNKNOWN;
        _this.jsonObj2Class(obj);
        return _this;
    }
    return Collaborate;
}(ValueObject));
export { Collaborate };
